import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap";
import React, { useEffect, useMemo, useState } from "react";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import TableContainer from "../../../../Components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getCrmItInvoiceSingleData,
  getCrmItInvoiceSingleDataSuccess,
  getMasterInvoiceList,
  getMasterInvoiceListCustomer,
} from "../../../../store/invoiceCrmIT/action";
import { getCompanyTeamMembersList } from "../../../../store/companyToUser/action";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { PdfToFile } from "../../../../Components/Common/pdfToFile";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import SettingsPanel from "../../components/SettingsPanel";

export default function Billing() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const { masterInvoiceListAPI, masterInvoiceListLoading } = useSelector(
    (state) => ({
      masterInvoiceListAPI:
        state.InvoiceCrmIT.masterInvoiceListCustomer?.invoice_list,
      masterInvoiceListLoading: state.InvoiceCrmIT.masterInvoiceListLoading,
    })
  );
  const { companyTeamMembersList } = useSelector((state) => ({
    companyTeamMembersList:
      state.CompanyToUser.companyTeamMembersList?.companytouser_list,
  }));
  const [fetchingInvoiceId, setFetchingInvoiceId] = useState(null);

  useEffect(() => {
    // dispatch(getMasterInvoiceList());
    dispatch(getMasterInvoiceListCustomer());
    dispatch(getCompanyTeamMembersList());
  }, []);

  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Title",
    "Total",
    "companyTeamMembersList",
    "User_UserLastName",
    "User_Email",
    "SubscriptionProduct_Name",
  ]);
  const [activeTab, setActiveTab] = useState("2");

  const { crmitInvoiceSinglePdfAPI, crmitInvoiceSinglePdfLoading } =
    useSelector((state) => ({
      crmitInvoiceSinglePdfAPI: state.InvoiceCrmIT.crmitInvoiceSinglePdf,
      crmitInvoiceSinglePdfLoading:
        state.InvoiceCrmIT.crmitInvoiceSinglePdfLoading,
    }));

  useEffect(() => {
    if (isEmpty(crmitInvoiceSinglePdfAPI)) return;
    if (crmitInvoiceSinglePdfAPI?.status === 200) {
      const file = PdfToFile(
        crmitInvoiceSinglePdfAPI?.invoice_pdf?.PdfBase64,
        crmitInvoiceSinglePdfAPI?.invoice_pdf?.Id
      );
      const link = document.createElement("a");
      link.href = file ? URL.createObjectURL(file) : "";
      link.download = file ? "Invoice nr: " + file.name : "";
      link.click();
    } else {
      toast.error(crmitInvoiceSinglePdfAPI?.message);
    }
    dispatch(getCrmItInvoiceSingleDataSuccess([]));
  }, [crmitInvoiceSinglePdfAPI]);

  useEffect(() => {
    let filteredCustomerList;
    if (activeTab === "1") {
      filteredCustomerList = companyTeamMembersList;
    }
    if (activeTab === "2") {
      filteredCustomerList = masterInvoiceListAPI;
    }

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key].toString().toLowerCase().includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, masterInvoiceListAPI, activeTab, companyTeamMembersList]);
  const columnsInvoices = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },

      {
        Header: " Date",
        accessor: "InvoiceDateTime",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {HandleDateTime(card.row.original?.InvoiceDateTime)}
              </span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Title",
        accessor: "Title",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>{card.row.original?.Title}</span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Total",
        accessor: "AmountLocalTotal",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>£{card.row.original?.AmountLocalTotal}</span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "InvoiceStatus_Name",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (cell) => {
          return (
            <div>
              <span className={""}></span>
              <div className={"badge text-uppercase"}>
                <span
                  style={{
                    background:
                      cell.row.original?.InvoiceStatus_CssColourBackground,
                    color: cell.row.original?.InvoiceStatus_CssColourText,
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  {cell.row.original?.InvoiceStatus_Name}
                </span>
              </div>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Download",
        accessor: "download",
        Cell: (card) => {
          return (
            <div>
              <button
                disabled={
                  crmitInvoiceSinglePdfLoading &&
                  card.row.original?.Id === fetchingInvoiceId
                }
                className={"btn btn-primary"}
                onClick={() => {
                  setFetchingInvoiceId(card.row.original?.Id);
                  dispatch(
                    getCrmItInvoiceSingleData({
                      id: card.row.original?.Id,
                    })
                  );
                }}
              >
                {crmitInvoiceSinglePdfLoading &&
                card.row.original?.Id === fetchingInvoiceId ? (
                  <span>
                    <i className="fa-solid fa-spinner fa-spin"></i> Downloading
                  </span>
                ) : (
                  "Download"
                )}
              </button>
            </div>
          );
        },
      },
    ],
    [crmitInvoiceSinglePdfLoading, fetchingInvoiceId]
  );

  const columnsTeamMembers = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "User_Id",
        filterable: false,
        Cell: (card) => (
          <>
            <span> #{card.row.original?.User_Id}</span>
          </>
        ),
      },
      {
        Header: "Full Name",
        accessor: "User_UserFullName",
        filterable: true,
        Cell: (card) => <>{card.row.original?.User_UserFullName || ""}</>,
      },
      {
        Header: "Email",
        accessor: "User_Email",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>{card.row.original?.User_Email}</span>
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Package",
        accessor: "SubscriptionProduct_Name",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {card.row.original?.SubscriptionProduct_Name}
              </span>
            </div>
          );
        },
        filterable: false,
      },
    ],
    []
  );
  const handleColumnDataStatus = (AmountUnCleared, AmountLocalTotal) => {
    switch (true) {
      case AmountUnCleared === 0:
        return (
          <div>
            <span className={"text-success"}>Paid</span>
          </div>
        );
      case AmountUnCleared === AmountLocalTotal:
        return (
          <div>
            <span className={"text-danger"}>UnPaid</span>
          </div>
        );
      default:
        return (
          <div>
            <span className={"text-warning"}>Part Paid</span>
          </div>
        );
    }
  };

  return (
    <SettingsPanel
      title="Invoices"
      description="View and download your CRMit subscription invoices."
    >
      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <Row className="g-4 align-items-center">
                <Col sm={3}>
                  <div className="search-box">
                    <Input
                      // create search with jobs List Data
                      type="search"
                      className="form-control search"
                      placeholder="Search for..."
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2"></div>
                </div>
              </Row>
            </CardHeader>
            <CardBody>
              {masterInvoiceListLoading ? (
                <LoadingSpinner />
              ) : (
                <TableContainer
                  columns={
                    activeTab === "1" ? columnsTeamMembers : columnsInvoices
                  }
                  data={searchResults || []}
                  isGlobalFilter={false}
                  isAddUserList={false}
                  customPageSize={10}
                  className="custom-header-css"
                  divClass="table-responsive table-card mb-0"
                  tableClass="align-middle table-nowrap"
                  theadClass="text-muted"
                  // handleLeadClick={handleLeadClicks}
                  isLeadsFilter={false}
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </SettingsPanel>
  );
}
